import { render, staticRenderFns } from "./my_point.vue?vue&type=template&id=ef59b36e&scoped=true"
import script from "./my_point.vue?vue&type=script&lang=js"
export * from "./my_point.vue?vue&type=script&lang=js"
import style0 from "./my_point.vue?vue&type=style&index=0&id=ef59b36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef59b36e",
  null
  
)

export default component.exports